import _ from 'lodash';

import {DataFactory} from './factory';

import {
  DASHBOARD_GET_CHART_DATA,
  DASHBOARD_GET_DATA,
  DASHBOARD_GET_GRID_DATA,
  DASHBOARD_GET_IFRAME_URL,
  DASHBOARD_GET_TITLE,
  DASHBOARD_GET_WORKSHEETS
} from './types';

export const getters = {
  [DASHBOARD_GET_DATA]: state => {
    return state.dashboard.data;
  },

  [DASHBOARD_GET_TITLE]: state => {
    return state.dashboard.title;
  },

  [DASHBOARD_GET_IFRAME_URL]: state => {
    return state.dashboard.url;
  },

  [DASHBOARD_GET_GRID_DATA]: state => {
    const data = state.dashboard;
    const type = (_.size(data.measures) && _.size(data.rows)) ? 'pivot' : 'grid';
    return DataFactory(Object.assign({}, data, {type}));
  },

  [DASHBOARD_GET_CHART_DATA]: state => {
    return DataFactory(state.dashboard);
  },

  [DASHBOARD_GET_WORKSHEETS]: state => {
    return state.dashboard.worksheets;
  }
};
